export const MEDICATION_ADMINISTRATION_STATUSES = ['taken', 'missed', 'not_taken'];

export const MEDICATION_NOT_TAKEN_REASONS = [
  ['refused', 'Refused'],
  ['sleeping', 'Sleeping'],
  ['vomited', 'Vomited / unable to take'],
  ['unavailable', 'Medication unavailable'],
  ['held', 'Held'],
  ['other', 'Other'],
];

export const isMedicationAdministrationResolved = (status) => MEDICATION_ADMINISTRATION_STATUSES.includes(status);
